import Vue from "vue";
import VueRouter from "vue-router";
import pcIndex from "../views/Home.vue";
import phoneIndex from "../views/phoneHome.vue";
import Main from "../Layout/main.vue";
import { visitorlogApi } from "@/api/website";
Vue.use(VueRouter);
let base = (function () {
  let path = location.pathname;
  console.log(9, path);
  let reg = /^\//;
  console.log(10, reg.test(path));
  if (reg.test(path)) {
    return "/dnnweb/";
  }
  return "/";
})();
const routes = [
  {
    path: "/",
    component: Main,
    redirect: "/pc_index",
    children: [
      {
        path: "/pc_index",
        name: "pcIndex",
        component: pcIndex,
      },

      {
        path: "/pc_index/news",
        name: "news",
        meta: {
          showContactUs: false,
        },
        component: () => import("../views/web/home/news/index.vue"),
      },
      {
        path: "/pc_index/newsDetail",
        name: "newsDetail",
        meta: {
          showContactUs: false,
        },
        component: () => import("../views/web/home/news/detail.vue"),
      },

      /******设计软件******/
      {
        path: "/digital",
        name: "digital",
        component: () => import("../views/web/digital/index.vue"),
      },
      {
        path: "/digital/airoad",
        name: "airoad",
        meta: {
          showContactUs: false,
        },
        component: () => import("../views/web/digital/airoad/index.vue"),
      },
      {
        path: "/digital/eicad",
        name: "eicad",
        meta: {
          showContactUs: false,
        },
        component: () => import("../views/web/digital/eicad/index.vue"),
      },
      {
        path: "/digital/report3d",
        name: "report3d",
        meta: {
          showContactUs: false,
        },
        component: () => import("../views/web/digital/report3d/index.vue"),
      },
      {
        path: "/digital/vrroad",
        name: "vrroad",
        meta: {
          showContactUs: false,
        },
        component: () => import("../views/web/digital/vrroad/index.vue"),
      },

      /******智能建造******/
      {
        path: "/intelligent",
        name: "intelligent",
        component: () => import("../views/web/intelligent/index.vue"),
      },
      {
        path: "/intelligent/management",
        name: "management",
        component: () =>
          import("../views/web/intelligent/management/index.vue"),
      },
      {
        path: "/intelligent/smartSite",
        name: "smartSite",
        component: () => import("../views/web/intelligent/smartSite/index.vue"),
      },
      {
        path: "/intelligent/prefabrication",
        name: "prefabrication",
        component: () =>
          import("../views/web/intelligent/prefabrication/index.vue"),
      },

      /******数字运维******/
      {
        path: "/dtwin",
        name: "dtwin",
        component: () => import("../views/web/dtwin/index.vue"),
      },

      /******狄诺尼学院******/
      {
        path: "/academy",
        name: "academy",
        meta: {
          showContactUs: false,
        },
        component: () => import("../views/web/academy/index.vue"),
      },

      /****** 软件下载 ******/
      {
        path: "/download",
        name: "download",
        component: () => import("../views/web/download/index.vue"),
      },

      // 下方是历史代码，暂时保留
      {
        path: "/phone_index",
        name: "phoneIndex",
        component: phoneIndex,
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  // base: process.env.BASE_URL,
  base: process.env.BASE_URL ? process.env.BASE_URL : "/",
  routes,
});

const routerVisitMap = [
  {name: "pcIndex", id: '1'},
  {name: "digital", id: '2'},
  {name: "intelligent", id: '3'},
  {name: "dtwin", id: '4'},
  {name: "academy", id: '5'},
  {name: "download", id: '6'},
]

router.beforeEach((to, from, next) => {
  const matchedRoute = routerVisitMap.find(item => item.name === to.name)
  const routerId = matchedRoute ? matchedRoute.id : ''

  if (routerId) {
    visitorlogApi({ module: routerId })
  }


  // debugger
  let path = [];
  let check = path.some((i) => {
    return i === to.path;
  });
  if (!check) {
    let sTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (sTop > 0) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
  }
  next();
});

export default router;
